export const DISPATCHER_PREFIX = '/rest';
export const MS_REQUEST_TIMEOUT = 1000;
